/* eslint-disable max-len, i18next/no-literal-string */
import React from 'react';

export function SpeechBubblesQuestionMark(): JSX.Element {
  return (
    <svg width='40' height='38' viewBox='0 0 40 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M35.963 31.0577L38 35.5L33.5185 33.8846C32.8395 34.6923 30.5852 35.5 27 35.5C22.5185 35.5 16 32.6731 16 25.4038C16 16.5192 21.2963 14.5 27 14.5C32.7037 14.5 38 18.5385 38 23.7885C38 29.0385 36.5062 30.3846 35.963 31.0577Z'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M4.5 21.5L2 27L7.5 25C8.33333 26 11.1 27 15.5 27C21 27 29 23.5 29 14.5C29 3.5 22.5 1 15.5 1C8.5 1 2 6 2 12.5C2 19 3.83333 20.6667 4.5 21.5Z'
        fill='#F1F3F5'
        stroke='#153F66'
        strokeWidth='2'
        strokeLinecap='round'
      />
      <path
        d='M14.8745 15.896H16.4605C16.3825 14.258 19.0085 14.505 19.0085 12.113C19.0085 10.54 17.8125 9.5 16.0055 9.5C14.1335 9.5 12.9375 10.644 13.0025 12.373L14.5625 12.529C14.4845 11.554 15.0565 10.917 16.0055 10.917C16.7855 10.917 17.3055 11.411 17.3055 12.126C17.3055 13.738 14.6925 13.556 14.8745 15.896ZM15.7325 18.808C16.3175 18.808 16.7465 18.379 16.7465 17.807C16.7465 17.235 16.3175 16.806 15.7325 16.806C15.1605 16.806 14.7185 17.235 14.7185 17.807C14.7185 18.379 15.1605 18.808 15.7325 18.808Z'
        fill='#FF3E51'
      />
    </svg>
  );
}
